import * as React from 'react';

import { ShipperAvatar } from './shipper-avatar';

// ─── Types ────────────────────────────────────────────────────────────────────

interface ShipperNameCellProps {
  logoUrl?: string;
  name: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ShipperNameCell({ logoUrl, name }: ShipperNameCellProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <ShipperAvatar className="ring-1 ring-border/40" logoUrl={logoUrl} name={name} />
      <span className="truncate text-sm font-medium">{name}</span>
    </div>
  );
}
